export default __webpack_public_path__ + "static/media/VO_DFDV.a00aafc2.gif";